import { HeroSection } from '@/components/landing/HeroSection';
import { DesktopAppSection } from '@/components/landing/DesktopAppSection';
import { SyncFlowSection } from '@/components/landing/SyncFlowSection';
import { WebAccessSection } from '@/components/landing/WebAccessSection';
import { CTASection } from '@/components/landing/CTASection';
import { Footer } from '@/components/layout/Footer';

/**
 * AboutPage Component
 * Landing page showcasing Omokage features
 * Accessible to both authenticated and non-authenticated users
 * Always displays the landing page content regardless of authentication status
 */
export function AboutPage() {
  return (
    <main className="min-h-screen bg-background">
      <HeroSection />
      <DesktopAppSection />
      <SyncFlowSection />
      <WebAccessSection />
      <CTASection />
      <Footer />
    </main>
  );
}

export default AboutPage;
